import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoCabra = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Cabra - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Cabra. Predicciones diarias de amor, trabajo y salud para los nacidos en los años de la Cabra." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="cabra" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Cabra</h1>
              <p className="text-muted-foreground">Años: 1931, 1943, 1955, 1967, 1979, 1991, 2003, 2015, 2027</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu naturaleza romántica y gentil está especialmente evidente hoy, Cabra. Tu sensibilidad emocional crea conexiones profundas. Las parejas disfrutarán de momentos tiernos y llenos de cariño.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu creatividad y sentido artístico brillarán hoy. Proyectos que requieren imaginación y buen gusto se beneficiarán de tu toque especial. Trabaja en ambientes armoniosos para mejores resultados.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu bienestar emocional es clave para tu salud física. Busca tranquilidad en la naturaleza o actividades artísticas. Evita ambientes estresantes que puedan afectar tu sensibilidad.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será ideal para expresar tus sentimientos con gestos creativos. Tu romanticismo natural tocará profundamente a tu pareja. Los solteros podrían conocer a alguien en entornos culturales.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu intuición artística te guiará hacia soluciones innovadoras. Colaboraciones armoniosas serán especialmente productivas. Confía en tu visión creativa para proyectos importantes.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía estará equilibrada. Actividades suaves como yoga o caminatas contemplativas nutrirán tu espíritu. Mantén la armonía en tu entorno para optimizar tu bienestar.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de dulzura y conexión emocional profunda. Tu capacidad de crear belleza en las relaciones fortalecerá los lazos con tu pareja. Los solteros atraerán personas sensibles y artísticas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu creatividad será tu mayor activo. Proyectos que requieren sensibilidad estética o comprensión emocional prosperarán. Busca colaboradores que compartan tu visión.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Prioriza la paz interior y el equilibrio emocional esta semana. Actividades que nutran tu alma creativa mejorarán tu bienestar general. Rodeate de belleza y armonía.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoCabra;
